import { render, staticRenderFns } from "./modulaStylePlain.vue?vue&type=template&id=72998abd&scoped=true&"
import script from "./modulaStylePlain.vue?vue&type=script&lang=js&"
export * from "./modulaStylePlain.vue?vue&type=script&lang=js&"
import style0 from "./modulaStylePlain.vue?vue&type=style&index=0&id=72998abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72998abd",
  null
  
)

export default component.exports